module.exports = __webpack_public_path__ + "static/media/18_3.870debdc.png";